import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-unregisterinfo',
  templateUrl: './unregisterinfo.component.html',
  styleUrls: ['./unregisterinfo.component.scss']
})
export class UnregisterinfoComponent {
  constructor(
    public dialogRef: MatDialogRef<UnregisterinfoComponent>
    ){}
    
  onConfirm(): void {
    this.dialogRef.close();
  }
}
